import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { AgreementsClient } from '@unity/clients';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { CardFundsExpensedSummarySharedComponent } from '@unity/shared/card-funds-expensed-summary-shared/card-funds-expensed-summary-shared.component';
import { CardItemCountSummarySharedComponent } from '@unity/shared/card-item-count-summary-shared/card-item-count-summary-shared.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridClientExpenseSharedComponent } from '@unity/shared/grid-client-expense-shared/grid-client-expense-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-client-expense-page',
  imports: [
    PageContainerComponent,
    GridClientExpenseSharedComponent,
    ActionSharedComponent,
    CardItemCountSummarySharedComponent,
    CardFundsExpensedSummarySharedComponent,
  ],
  templateUrl: './list-client-expense-page.component.html',
  styleUrl: './list-client-expense-page.component.scss',
})
export class ListClientExpensePageComponent {
  private readonly agreementsClient = inject(AgreementsClient);

  public readonly $agreementId = input.required({ alias: 'agreementId', transform: (value: string) => parseInt(value) });

  protected readonly agreementResource = rxResource({
    params: () => {
      const agreementId = this.$agreementId();
      return agreementId ? { agreementId } : undefined;
    },
    stream: ({ params: { agreementId } }) => this.agreementsClient.getOneAsMini(agreementId),
  });

  protected readonly agreementStatsResource = rxResource({
    params: () => {
      const agreementId = this.$agreementId();
      return agreementId ? { agreementId } : undefined;
    },
    stream: ({ params: { agreementId } }) => this.agreementsClient.getOneAsStats(agreementId),
  });

  protected readonly $createClientExpenseAction = computed(() => {
    const agreementId = this.$agreementId();
    return QuickActions.CreateClientExpense(agreementId);
  });

  protected readonly $agreement = computed(() => (this.agreementResource.hasValue() ? this.agreementResource.value() : undefined));

  protected readonly $agreementStats = computed(() =>
    this.agreementStatsResource.hasValue() ? this.agreementStatsResource.value() : undefined
  );

  protected readonly $contentHeaderSecondary = computed(() => {
    const agreement = this.$agreement();
    return `Agreement: ${agreement?.name}`;
  });

  protected readonly $returnToAgreementAction = computed(() => QuickActions.ReturnToAgreement(this.$agreementId()));
}
